<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <example-title src="example-1.html" title="Single line text input" />
    <vc-layout :spacing="8">
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">With default value</h4>
        <vc-text type="text" v-model="text1" name="text-1" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Placeholder text</h4>
        <vc-text type="text" v-model="text2" :placeholder="placeholder" name="text-2" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Floating label</h4>
        <vc-text type="text" v-model="text3" :label="label" name="text-3" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Label and placeholder text</h4>
        <vc-text type="text" v-model="text4" :label="label" :placeholder="placeholder" name="text-4" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon</h4>
        <vc-text type="text" v-model="text5" icon-left="home" name="text-5" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon and label</h4>
        <vc-text type="text" v-model="text6" :label="label" icon-left="home" name="text-6" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon and placeholder text</h4>
        <vc-text type="text" v-model="text7" :placeholder="placeholder" icon-left="home" name="text-7" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon, label and placeholder text</h4>
        <vc-text type="text" v-model="text8" :label="label" :placeholder="placeholder" icon-left="home" name="text-8" color="primary" />
      </vc-col>
    </vc-layout>
    <example-title src="example-2.html" title="Password input" />
    <vc-layout :spacing="8">
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Default look and feel</h4>
        <vc-text type="password" name="password-1" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Placeholder text</h4>
        <vc-text type="password" :placeholder="placeholder" name="password-2" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Floating label</h4>
        <vc-text type="password" :label="label" name="password-3" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Label and placeholder text</h4>
        <vc-text type="password" :label="label" :placeholder="placeholder" name="password-4" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon</h4>
        <vc-text type="password" icon-left="vpn_key" name="password-5" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon and floating label</h4>
        <vc-text type="password" :label="label" icon-left="vpn_key" name="password-6" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon and placeholder text</h4>
        <vc-text type="password" :placeholder="placeholder" icon-left="vpn_key" name="password-7" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon, label and placeholder text</h4>
        <vc-text type="password" :label="label" :placeholder="placeholder" icon-left="vpn_key" name="password-8" color="primary" />
      </vc-col>
    </vc-layout>
    <example-title src="example-3.html" title="Multiline textbox (textarea)" />
    <vc-layout :spacing="8">
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Default look and feel</h4>
        <vc-text type="textarea" v-model="textarea1" name="textarea-1" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Placeholder text</h4>
        <vc-text type="textarea" :placeholder="placeholder" name="textarea-2" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Floating label</h4>
        <vc-text type="textarea" :label="label" name="textarea-3" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Label and placeholder text</h4>
        <vc-text type="textarea" :label="label" :placeholder="placeholder" name="textarea-4" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon</h4>
        <vc-text type="textarea" icon-left="email" name="textarea-5" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon and floating label</h4>
        <vc-text type="textarea" :label="label" icon-left="email" name="textarea-6" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon and placeholder</h4>
        <vc-text type="textarea" :placeholder="placeholder" icon-left="email" name="textarea-7" color="primary" />
      </vc-col>
      <vc-col :span="8" sm12 xs24>
        <h4 :class="subHeading">Icon, label and placeholder text</h4>
        <vc-text type="textarea" :label="label" :placeholder="placeholder" icon-left="email" name="textarea-8" color="primary" />
      </vc-col>
    </vc-layout>
    <example-title src="example-4.html" title="Clearable text input" />
    <p>To clear the current value of the input boxes below, press the "x" button on their right sides.</p>
    <div :class="['my-16']">
      <code>v-model: {{ clearable1 }}</code>
    </div>
    <vc-text
      type="text"
      color="pink"
      name="clearable-1"
      v-model="clearable1"
      label="This is clearable input"
      placeholder="Type something"
      clearable
      icon-left="mdi-pencil" />
    <div :class="['my-16']">
      <code>v-model: {{ clearable2 }}</code>
    </div>
    <vc-text
      type="password"
      color="orange"
      name="clearable-2"
      v-model="clearable2"
      label="This is clearable password"
      placeholder="Type password"
      clearable
      icon-left="vpn_key" />
    <div :class="['my-16']">
      <code>v-model: {{ clearable3 }}</code>
    </div>
    <vc-text
      type="textarea"
      color="green"
      name="clearable-3"
      v-model="clearable3"
      label="This is clearable textarea"
      placeholder="Type something"
      clearable
      icon-right="mdi-email-outline" />
    <example-title src="example-5.html" title="Reveal Password" />
    <p>Type in the password box below and press the "eye" icon on its right side to reveal the password.</p>
    <div :class="['my-16']">
      <code>v-model: {{ reveal1 }}</code>
    </div>
    <vc-text
      type="password"
      reveal color="pink"
      name="reveal-1"
      v-model="reveal1"
      label="This is clearable password"
      placeholder="Type password"
      clearable
      icon-left="vpn_key" />
    <example-title src="example-6.html" title="@input event" />
    <div :class="['my-16']">
      <code>v-model: {{ input1 }}</code>
    </div>
    <vc-text
      type="text"
      color="pink"
      name="input-1"
      v-model="input1"
      label="Open your browser's console and input some data"
      clearable
      @input="input($event)"
      icon-left="search" />
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'TextPage',
  data () {
    return {
      title: null,
      description: null,
      placeholder: 'Placeholder text',
      label: 'Label Text',
      titleCss: ['title', 'font-grey', 'font-l-600'],
      subHeading: ['subheading', 'font-grey', 'font-l-600', 'mx-0', 'my-16'],
      text1: 'default value',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
      text6: '',
      text7: '',
      text8: '',
      textarea1: 'default value',
      clearable1: '',
      clearable2: '',
      clearable3: '',
      reveal1: '',
      input1: ''
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    input (data) {
      console.log('@input', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/text.vue